const mEditionBillingMyPaymentsPaymentMethod = {
  mEditionBillingMyPaymentsPaymentMethod: {
    paragraph: {
      line1: 'Actualmente tienes un plan',
      strong: 'Gratuito.',
      line2: 'puedes cambiar el medio y mantener todas las características de tu plan actual.'
    },
    paragraphElse: {
      change: 'CAMBIAR MEDIO DE PAGO',
      line1: 'Tu medio de pago actual es ',
      line2: 'puedes cambiar el medio y mantener todas las características de tu plan actual.'
    },

    paragraphPlanChangePending: {
      text: '¡Hemos detectado un intento de cambio de Cambio de Plan!',
      btn: 'VER DETALLE'
    },

    paragraphPaymentMethodChangePending: {
      text: '¡Hemos detectado un intento de Cambio de Medio de Pago!',
      btn: 'VER DETALLE'
    }
  }
}

export default mEditionBillingMyPaymentsPaymentMethod
